class ScriptLoaderService {

    private static readonly ALREADY_LOADED_SCRIPTS: { [path: string]: Promise<void> } = {};

    public loadScript(path: string) {
        return new Promise((outerResolve, reject) => {
            if (!ScriptLoaderService.ALREADY_LOADED_SCRIPTS[path]) {
                ScriptLoaderService.ALREADY_LOADED_SCRIPTS[path] = new Promise(((innerResolve, reject1) => {
                    this.appendScript(path, () => {
                        innerResolve();
                        outerResolve(undefined); // check is this is executed. otherwise invert lines
                    });
                }));
            } else {
                ScriptLoaderService.ALREADY_LOADED_SCRIPTS[path].then(() => {
                    outerResolve(undefined);
                });
            }
        });
    }

    private appendScript(path: string, callback: () => void) {
        const scriptTag: HTMLScriptElement = document.createElement('script');
        scriptTag.src = path;
        scriptTag.onload = callback;
        document.head.appendChild(scriptTag);
    }

}

const SCRIPTLOADER_SERVICE_INSTANCE = new ScriptLoaderService();

export {SCRIPTLOADER_SERVICE_INSTANCE};
